import { render, staticRenderFns } from "./SubmenuSidebarItem.vue?vue&type=template&id=36c7dee7&scoped=true"
import script from "./SubmenuSidebarItem.vue?vue&type=script&lang=js"
export * from "./SubmenuSidebarItem.vue?vue&type=script&lang=js"
import style0 from "./SubmenuSidebarItem.vue?vue&type=style&index=0&id=36c7dee7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c7dee7",
  null
  
)

export default component.exports